import axios from 'axios';
import { BASE_URL } from '@/config/api';
import { Toast } from 'vant';

const config = {
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data, headers) {
    if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      const params = new URLSearchParams();
      params.append('data', JSON.stringify(data));
      return params;
    } else {
      // 其他类型
      return data;
    }
  }],
  withCredentials: true
};

const axiosInstance = axios.create(config);

axiosInstance
  .interceptors
  .response
  .use(res => {
    const code = res.data.code;
    if (code === -1001) { // 处理未登录的情况
      if (localStorage.getItem('auth')) {
        localStorage.removeItem('auth');
        location.reload();
      }
      return Promise.reject(res.data);
    } else if (code !== 0) {
      if (code === -6001) {
        Toast('表单不存在');
      }
      return Promise.reject(res.data);
    } else { // 正常返回
      return res.data;
    }
  });

axiosInstance
  .interceptors
  .request
  .use(config => {
    config.headers['Auth'] = localStorage.getItem('auth') || '';
    return config;
  });

const $http = axiosInstance;

export default $http;
